import React,{useState,useEffect} from 'react';
import Navbarmenu from '../menu/Navbarmenu';
import Footer from '../Footer';

const Layout =({children}) =>{
  useEffect( () => {
    window.addEventListener('scroll', toggleVisibility);
  }, []);

  const [is_stickymenu, set_stickymenu] = useState(false);

  const toggleVisibility =()=> {
    if (window.pageYOffset > 177) {
      set_stickymenu(true);
    } else {
      set_stickymenu(false);
    }
  }
  return(<>
    <Navbarmenu stickysss={is_stickymenu} />
    <div className="clearfix"></div>
    <main className="default__height">{children}</main>
    <div className="clearfix"></div>
    <Footer />
  </>)
}

export default Layout;